<template>

<div class="top-header">
    <div class="inner-body-block" v-if="mainStore.location">
        <LazyIdleHeaderCitySelector hydrate-on-idle></LazyIdleHeaderCitySelector>
        <span v-if="phoneNumber">{{ phoneNumber }}</span>
        <nuxt-link to="/about/stores/" class="label">
            Адреса магазинов
            <span class="badge" v-if="mainStore.location.retail.count">{{mainStore.location.retail.count}}</span>
        </nuxt-link>

        <div style="flex: 1;"></div>
        <!-- <img class="header-icon" src="~/assets/icons/header/delivery.svg"> -->
        <nuxt-link to="/about/delivery/">Доставка</nuxt-link>
        <!-- <img class="header-icon" src="~/assets/icons/header/info.svg"> -->
        <nuxt-link to="/about/company/">О компании</nuxt-link>
        <!-- <nuxt-link to="/3d/">3D программа</nuxt-link> -->
        <nuxt-link to="/about/contacts/">Контакты</nuxt-link>
        <nuxt-link to="/personal/orders/">
            Заказы
            <span class="badge" v-if="mainStore.ordersCount">{{mainStore.ordersCount}}</span>
        </nuxt-link>
        <header-login-button></header-login-button>
    </div>
</div>

</template>

<script setup lang="ts">
import { useMainStore } from '~/store/mainState';

const mainStore = useMainStore();

const phoneNumber = computed(() => {
    if (!mainStore.location?.contact.phones.length) {
        return null;
    }

    return mainStore.location.contact.phones[0];
})

</script>

<style lang="scss" src="./style.scss" scoped></style>
